import { render, staticRenderFns } from "./DefaultHomeView.vue?vue&type=template&id=52a53bfb&"
import script from "./DefaultHomeView.vue?vue&type=script&lang=js&"
export * from "./DefaultHomeView.vue?vue&type=script&lang=js&"
import style0 from "./DefaultHomeView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52a53bfb')) {
      api.createRecord('52a53bfb', component.options)
    } else {
      api.reload('52a53bfb', component.options)
    }
    module.hot.accept("./DefaultHomeView.vue?vue&type=template&id=52a53bfb&", function () {
      api.rerender('52a53bfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Home/DefaultHomeView.vue"
export default component.exports